import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Coverages } from "@/components/site/Coverages";
import { Insurers } from "@/components/site/Insurers";
import { Stats } from "@/components/site/Stats";
import { Testimonials } from "@/components/site/Testimonials";
import { Faq } from "@/components/site/Faq";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, anchors: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="bg-bone text-ink min-h-screen" data-testid="policyone-app">
            <Nav />
            <main>
                <Hero />
                <Marquee />
                <Manifesto />
                <Coverages />
                <Insurers />
                <Stats />
                <Testimonials />
                <Faq />
                <QuoteForm />
            </main>
            <Footer />
            <WhatsAppButton />
            <Toaster position="bottom-left" />
        </div>
    );
}

export default App;
